<template>
  <div class="appraise-detail container">
    <div class="title">
      <el-button
        type="text"
        icon="el-icon-arrow-left"
        class="back-btn"
        @click="$router.go(-1)"
        >返回</el-button
      >
      <b>素养评价</b>
      <el-button
        type="primary"
        size="mini"
        icon="el-icon-coin"
        class="submit-btn"
        @click="handleSubmit"
        >提交评分</el-button
      >

      <p class="stundent-name">
        学生：<span>{{ $route.query.nickName }}</span>
      </p>
    </div>
    <div class="main">
      <div class="box" v-for="(item, idx) in list" :key="idx">
        <p class="box_title">{{ item.title }}</p>
        <div class="content">
          <div class="one_row" v-for="(row, idx) in item.items" :key="idx">
            <span>{{ idx + 1 }}.</span>
            <span style="margin-right: 20px">{{ row.name }}</span>
            <el-input-number
              v-model="scoreDetail[row.score]"
              :min="0"
              :max="4"
              size="small"
            ></el-input-number>
          </div>
        </div>
      </div>
      <template v-if="scoreDetail.otherList.length > 0">
        <div
          class="box otherList"
          v-for="(item, i) in scoreDetail.otherList"
          :key="i + 9"
        >
          <p class="box_title">
            课堂素养考核{{ i + 1 }}
            <i
              class="el-icon-close"
              v-show="!info.syComplete"
              @click="handleDel(i)"
            ></i>
          </p>
          <div class="content" style="text-align: left">
            <el-form :model="item" ref="form" size="small" label-width="50px">
              <el-form-item label="项目:" prop="label">
                <el-select
                  v-model="item.label"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择项目"
                >
                  <el-option
                    v-for="o in options"
                    :key="o"
                    :label="o"
                    :value="o"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="分数:" prop="score">
                <el-input-number
                  v-model="item.score"
                  :min="-10"
                  :max="10"
                ></el-input-number>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </template>
      <div
        class="box plus"
        @click="scoreDetail.otherList.push({ label: '', score: 0 })"
      >
        <div class="add-tips">
          <p>点击添加</p>
          <p>课堂素养考核项</p>
        </div>
        <i class="el-icon-circle-plus"></i>
      </div>
      <!-- <div class="box btn-box">
        <el-button
          v-show="!info.syComplete"
          type="primary"
          icon="el-icon-coin"
          @click="handleSubmit"
          >提交评分</el-button
        >
      </div> -->
    </div>
  </div>
</template>

<script>
import { appraiseDetail, saveAppraise } from "@/api/assistantMode/chapter";

export default {
  props: {
    info: Object,
  },
  data() {
    return {
      list: [
        {
          title: "社会责任",
          items: [
            {
              name: "诚信友善",
              score: "cxys",
            },
            {
              name: "合作担当",
              score: "hzdd",
            },
            {
              name: "法制信仰",
              score: "fzxy",
            },
            {
              name: "生态意识",
              score: "stcs",
            },
          ],
        },
        {
          title: "国家认同",
          items: [
            {
              name: "国家意识",
              score: "gjys",
            },
            {
              name: "政治认同",
              score: "zzrt",
            },
            {
              name: "文化自信",
              score: "whzx",
            },
          ],
        },
        {
          title: "国际理解",
          items: [
            {
              name: "全球视野",
              score: "qqsy",
            },
            {
              name: "尊重差异",
              score: "zzcy",
            },
          ],
        },
        {
          title: "人文底蕴",
          items: [
            {
              name: "人文积淀",
              score: "rwjd",
            },
            {
              name: "人文情怀",
              score: "rwqh",
            },
          ],
        },
        {
          title: "科学精神",
          items: [
            {
              name: "崇尚真知",
              score: "cszz",
            },
            {
              name: "理性思维",
              score: "lxsw",
            },
            {
              name: "勇于研究",
              score: "yyyj",
            },
          ],
        },
        {
          title: "审美情趣",
          items: [
            {
              name: "感悟鉴赏",
              score: "gwjs",
            },
            {
              name: "创意表达",
              score: "cybd",
            },
          ],
        },
        {
          title: "学会学习",
          items: [
            {
              name: "乐学善学",
              score: "lxsx",
            },
            {
              name: "勤于反思",
              score: "qyfs",
            },
            {
              name: "数字学习",
              score: "szxx",
            },
          ],
        },
        {
          title: "身心健康",
          items: [
            {
              name: "珍爱生命",
              score: "zasm",
            },
            {
              name: "健全人格",
              score: "jqrg",
            },
            {
              name: "适性发展",
              score: "sxfz",
            },
          ],
        },
        {
          title: "实践创新",
          items: [
            {
              name: "热爱劳动",
              score: "rald",
            },
            {
              name: "批判质疑",
              score: "ppzy",
            },
            {
              name: "问题解决",
              score: "wtjj",
            },
          ],
        },
      ],
      scoreDetail: {
        classChapterId: null,
        userId: null,
        cxys: 3,
        hzdd: 3,
        fzxy: 3,
        stcs: 3,
        gjys: 3,
        zzrt: 3,
        whzx: 3,
        qqsy: 3,
        zzcy: 3,
        rwjd: 3,
        rwqh: 3,
        cszz: 3,
        lxsw: 3,
        yyyj: 3,
        gwjs: 3,
        cybd: 3,
        lxsx: 4,
        qyfs: 4,
        szxx: 3,
        zasm: 3,
        jqrg: 4,
        sxfz: 3,
        rald: 4,
        ppzy: 4,
        wtjj: 3,
        otherList: [],
      },
      options: [
        "上课期间手机未上交",
        "玩手机、玩电脑（打开与上课无关页面）",
        "嬉笑打闹、大声喧哗",
        "上课睡觉",
        "不交作业",
        "迟到或未按时签到",
        "老师讲课期间戴耳机",
        "自己随意调换座位",
        "上课期间组员不得去其他组",
        "上课带零食、吃零食、带杯装饮料等进实训室",
        "积极参与回答问题",
        "积极组织讨论",
        "优秀作业",
        "遵守纪律",
        "积极提问（问作业做什么的除外）",
        "小组全部交齐作业",
        "认真听课记笔记",
        "辅助老师完成工作",
      ],
    };
  },
  activated() {
    this.getDetail();
  },
  deactivated() {
    this.scoreDetail = this.$options.data().scoreDetail;
  },
  methods: {
    getDetail() {
      let classChapterId = this.$route.query.classChapterId;
      let userId = this.$route.query.userId;
      this.$loading.show();
      appraiseDetail({ classChapterId, userId }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          if (res.data) this.scoreDetail = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleDel(idx) {
      this.$confirm("确定要删除该项吗?", {
        type: "warning",
      })
        .then(() => {
          this.scoreDetail.otherList.splice(idx, 1);
        })
        .catch(() => {});
    },
    handleSubmit() {
      this.scoreDetail.classChapterId = this.$route.query.classChapterId;
      this.scoreDetail.userId = this.$route.query.userId;
      this.$loading.show();
      delete this.scoreDetail.total;
      saveAppraise(this.scoreDetail).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.$message.success("评分成功");
          this.getDetail();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.appraise-detail {
  padding: 20px 0;
  height: 100%;
  overflow: inherit;
  .title {
    position: relative;
    height: 52px;
    line-height: 52px;
    text-align: center;
    border-radius: 2px;
    background-color: #fff;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.15);
    .back-btn {
      position: absolute;
      left: 20px;
      top: 50%;
      transform: translateY(-50%);
    }
    b {
      font-size: 20px;
    }
    .submit-btn {
      position: absolute;
      right: 20px;
      top: 50%;
      transform: translateY(-50%);
    }
    .stundent-name {
      position: absolute;
      right: 140px;
      top: 50%;
      transform: translateY(-50%);
      span {
        color: #1890ff;
      }
    }
  }
  .main {
    margin: 10px -10px;
    text-align: left;
    height: calc(100% - 52px - 20px);
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 4px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      background-color: #c8c8c8;
    }
    .box {
      display: inline-block;
      margin: 10px;
      width: 284px;
      height: 268px;
      text-align: center;
      box-shadow: 0 0 4px rgba(0, 0, 0, 0.15);
      vertical-align: top;
      &.plus {
        position: relative;
        line-height: 268px;
        background-color: #fff;
        cursor: pointer;
        &:hover {
          .el-icon-circle-plus {
            color: #409eff;
          }
        }
        .el-icon-circle-plus {
          margin-top: 100px;
          font-size: 80px;
          color: #606266;
          transition: all 0.3s ease;
        }
        .add-tips {
          position: absolute;
          top: 40px;
          left: 50%;
          transform: translateX(-50%);
          width: 100%;
          line-height: 1;
          font-size: 16px;
          color: #909399;
          p {
            margin-bottom: 10px;
          }
        }
      }
      .box_title {
        padding: 0 10px;
        height: 48px;
        line-height: 48px;
        font-size: 16px;
        background-color: #f7f9fa;
        .el-icon-close {
          float: right;
          margin-top: 15px;
          font-size: 20px;
          transition: all 0.3s ease;
          cursor: pointer;
          &:hover {
            color: #f56c6c;
          }
        }
      }
      .content {
        padding: 20px;
        height: 220px;
        background-color: #fff;
        .one_row {
          //   padding: 6px 0;
          margin-bottom: 10px;
          font-size: 16px;
        }

        ::v-deep .memo-input {
          margin-top: 10px;
          .el-textarea__inner {
            font-family: inherit;
            color: inherit;
          }
        }
      }
      &.btn-box {
        box-shadow: inherit;
        line-height: 268px;
      }
    }
  }
}
</style>